import type { memberSecurityStatusResponse } from '@/api/member'

/** 登录后安全引导弹窗类型，按优先级依次展示 */
export type SecurityPromptType = 'account_upgrade' | 'bind_phone' | 'set_pin' | 'kyc_verify'

export type MemberSecurityStatus = memberSecurityStatusResponse

/** 弹窗展示优先级（索引越小越优先） */
export const SECURITY_PROMPT_PRIORITY: SecurityPromptType[] = [
  'account_upgrade',
  'set_pin',
  'bind_phone',
  'kyc_verify',
]

export type SecurityPromptResolver = (status: MemberSecurityStatus) => SecurityPromptType[]

/** 除实名外无其他待处理项时，应跳转实名认证页 */
export function shouldRedirectToKycVerify(status: MemberSecurityStatus): boolean {
  return !status.has_kyc && resolveSecurityPrompts(status).length === 0
}

/**
 * 根据安全状态解析待展示的弹窗队列。
 * 实名认证不在此队列中，由 securityPrompt store 在其他项处理完后跳转 /user/verify-real。
 */
export const resolveSecurityPrompts: SecurityPromptResolver = (status) => {
  const pending: SecurityPromptType[] = []
  if (!status.has_account) pending.push('account_upgrade')
  if (!status.has_pin) pending.push('set_pin')
  if (!status.has_phone) pending.push('bind_phone')

  return pending.sort(
    (a, b) => SECURITY_PROMPT_PRIORITY.indexOf(a) - SECURITY_PROMPT_PRIORITY.indexOf(b),
  )
}
